<script setup>
import { computed, inject, onMounted } from "vue";
import { useRun } from "~/composables/useRun";
import { runLabel } from "~/utils/runLabel";
import PageShell from "~/components/PageShell.vue";
import GlLoadingIcon from "~/components/gitlab/GlLoadingIcon.vue";
import GlAlert from "~/components/gitlab/GlAlert.vue";
import RunLog from "~/components/RunLog.vue";

const { jobId, projectId, runId } = defineProps({
  jobId: { required: true, type: String },
  projectId: { required: true, type: String },
  runId: { required: true, type: String }
});

const isAdmin = inject("isAdmin", false);

const { run, loading, error, fetchRun, clearError } = useRun(runId);

const breadcrumbs = computed(() => [
  { href: `/projects/${projectId}`, text: run.value ? run.value.projectName : "…" },
  { href: `/projects/${projectId}/jobs/${jobId}/runs`, text: `Job #${jobId}` },
  { text: `Run #${runId}` }
]);

onMounted(fetchRun);
</script>

<template>
  <PageShell :breadcrumbs="breadcrumbs">
    <!-- Loading -->
    <div v-if="loading" class="flex justify-center py-12">
      <GlLoadingIcon size="lg" />
    </div>

    <!-- Error -->
    <GlAlert v-else-if="error" variant="danger" @dismiss="clearError">{{ error }}</GlAlert>

    <!-- Content -->
    <template v-else-if="run">
      <h2 class="pb-4 text-lg font-semibold text-[var(--gl-text-color-heading)]">
        {{ runLabel(run.name) }} #{{ runId }}
      </h2>
      <RunLog :run-id="runId" :is-admin="isAdmin" />
    </template>
  </PageShell>
</template>
